import React from 'react';
import PropTypes from 'prop-types';

import translate from '../../../../utils/translations';
import {RequestText} from '../RequestText/RequestText';
import {Button} from '@homeaway/react-buttons';
import {ALERT_SUCCESS__32} from '@homeaway/svg-defs/lib/defs/ALERT_SUCCESS__32';
import {SVGIcon} from '@homeaway/react-svg';
import edap from '@homeaway/edap-wrapper';
import InsuranceFailedMessages from '../../ErrorMessages/InsuranceFailedMessages';

import './ConfirmationSteps.less';

export class ConfirmationSteps extends React.PureComponent {
    static propTypes = {
        email: PropTypes.string,
        hostName: PropTypes.string,
        instantBooking: PropTypes.bool.isRequired,
        isIpm: PropTypes.bool,
        isVrboIpmStaticMessaging: PropTypes.bool,
        reservationId: PropTypes.string,
        reservationStatus: PropTypes.string,
        translations: PropTypes.shape({}).isRequired,
        confirmation: PropTypes.shape({}),
        tripDetailsUrl: PropTypes.string.isRequired,
    };

    static defaultProps = {
        translations: {},
    };

    onClickViewTripDetails() {
        edap().push({
            name: 'generic.click',
            data: {
                eventaction: 'trip.details.click',
                eventcategory: 'traveler activity',
                eventlabel: 'confirmation cta',
            },
        });
    }

    renderInstantBookingText(isIpm, isVrboIpmStaticMessaging, translations) {
        let instantBookingText = 'th.confirmation.steps.instant.text';

        if (isVrboIpmStaticMessaging) {
            instantBookingText = isIpm
                ? 'th.confirmation.steps.instant.text.forIpm.instantBooking'
                : 'th.confirmation.steps.instant.text';
        }

        return (
            <div className="ConfirmationSteps__instant-text">
                {translate(
                    translations,
                    'trav-dash/trav-home',
                    'messages',
                    instantBookingText
                )}
            </div>
        );
    }

    render() {
        const {
            email,
            instantBooking,
            reservationId,
            reservationStatus,
            translations,
            confirmation,
            tripDetailsUrl,
            hostName,
            isIpm,
            isVrboIpmStaticMessaging,
        } = this.props;

        const shouldNotAddCssClasses = isIpm && isVrboIpmStaticMessaging;

        return (
            <div
                className={`ConfirmationSteps col-sm-12 ${
                    shouldNotAddCssClasses ? '' : 'col-md-offset-2 col-md-8'
                }`}
            >
                <span
                    className={`text-success ${
                        shouldNotAddCssClasses ? '' : 'hidden-xs'
                    }`}
                >
                    <SVGIcon markup={ALERT_SUCCESS__32} useFill />
                </span>
                <RequestText
                    email={email}
                    confirmed={
                        instantBooking || reservationStatus === 'CONFIRMED'
                    }
                    hostName={hostName}
                    instantBooking={instantBooking}
                    isVrboIpmStaticMessaging={isVrboIpmStaticMessaging}
                    isIpm={isIpm}
                    translations={translations}
                    reservationId={reservationId}
                    tripDetailsUrl={tripDetailsUrl}
                />
                {instantBooking &&
                    this.renderInstantBookingText(
                        isIpm,
                        isVrboIpmStaticMessaging,
                        translations
                    )}
                <InsuranceFailedMessages
                    className="ConfirmationSteps__insurance-messages"
                    confirmation={confirmation}
                    translations={translations}
                />
                <Button
                    className="ConfirmationSteps__button"
                    href={tripDetailsUrl}
                    label={translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.confirmation.cta'
                    )}
                    onClick={this.onClickViewTripDetails}
                />
            </div>
        );
    }
}
